import { gql } from "@apollo/client";

export const GET_CERTIFICATE_PDF_URL = gql`
  query getCertificateUrlById($id: uuid) {
    courses_certificates(where: { id: { _eq: $id } }) {
      certificate_pdf_url
    }
  }
`;
